import { render, staticRenderFns } from "./ModalSuporteTipoAcomodacao.vue?vue&type=template&id=7ff001dc&scoped=true"
import script from "./ModalSuporteTipoAcomodacao.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteTipoAcomodacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteTipoAcomodacao.vue?vue&type=style&index=0&id=7ff001dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff001dc",
  null
  
)

export default component.exports